module.exports = __webpack_public_path__ + "img/syfol-login-logo.3b4ffdf3.png";